import React from 'react'
import { Tab, Tabs } from 'react-bootstrap'
const UserImg = require('../../assets/image/user-i.jpg')
function DetailFeedback() {
    return (
        <>
            <div className=' imagebox image flex gap-5'>
                <div className=' flex gap-2 items-center'>
                    <img src={UserImg} alt="user" className="w-16 h-16 rounded-full" />
                    <div className=' flex-col'>
                        <p className=' font-bold '>  Mukesh Yadav </p>
                        <p className=' text-gray-500'>Teacher</p>
                    </div>
                </div>
                <div className=' flex gap-2 items-center'>
                    <img src={UserImg} alt="user" className="w-16 h-16 rounded-full" />
                    <div className=' flex-col'>
                        <p className=' font-bold '>  Mukesh Yadav </p>
                        <p className=' text-gray-500'>Teacher</p>
                    </div>
                </div>

            </div>


            <Tabs defaultActiveKey="Observation_form" transition={true} className=" my-3 mt-5 nav-pills-tabs " variant="pills">

                <Tab eventKey="Observation_form" title="Observation form">
                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4">

                        <div class=" bg-[#E5DED4] bg-opacity-25 rounded-md p-3   gap-4">
                            <p className=' text-black font-bold text-[12px] '>
                                The teacher is using the teacher's guid.She holds it refer to it during the lesson.
                            </p>
                            <p className=' text-[10px] text-black mt-6'>Ans: No/Partially</p>
                            <hr className="border-t border-gray-400 my-2" />
                            <p className=' text-gray-600 text-[10px] my-3'>Reason to sekect No/Partially</p>
                            <p className='text-[10px] text-black'>Lorem ipsum sit ame</p>
                        </div>

                        <div class=" bg-[#E5DED4] bg-opacity-25 rounded-md p-3   gap-4">
                            <p className=' text-black font-bold text-[12px] '>
                                The teacher is using the teacher's guid.She holds it refer to it during the lesson.
                            </p>
                            <p className=' text-[10px] text-black mt-2'>Ans: No/Partially</p>
                            <hr className="border-t border-gray-400 my-2" />
                            <p className=' text-gray-600 text-[10px]'>Comment</p>
                            <p className='text-[10px] text-black'> Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ipsa dolorum quam fugiat expedita quis dolorem?</p>
                            <hr className="border-t border-gray-400 my-2" />
                            <p className=' text-gray-600 text-[10px]'>Reason to sekect No/Partially</p>
                            <p className='text-[10px] text-black'>Lorem ipsum sit ame</p>
                        </div>

                        <div class=" bg-[#E5DED4] bg-opacity-25 rounded-md p-3   gap-4">
                            <p className=' text-black font-bold text-[12px] '>
                                The teacher is using the teacher's guid.She holds it refer to it during the lesson.
                            </p>
                            <p className=' text-[10px] text-black mt-2'>Ans: No/Partially</p>

                        </div>

                        <div class=" bg-[#E5DED4] bg-opacity-25 rounded-md p-3   gap-4">
                            <p className=' text-black font-bold text-[12px] '>
                                The teacher is using the teacher's guid.She holds it refer to it during the lesson.
                            </p>
                            <p className=' text-[10px] text-black mt-2'>Ans: No/Partially</p>
                            <hr className="border-t border-gray-400 my-2" />
                            <p className=' text-gray-600 text-[10px] my-3'>Comment</p>
                            <p className='text-[10px] text-black'> Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ipsa dolorum quam fugiat expedita quis dolorem?</p>
                            <hr className="border-t border-gray-400 my-2" />
                            <p className=' text-gray-600 text-[10px]'></p>
                            <p className='text-[10px] text-black mt-3'></p>
                        </div>
                        <div class=" bg-[#E5DED4] bg-opacity-25 rounded-md p-3   gap-4">
                            <p className=' text-black font-bold text-[12px] '>
                                The teacher is using the teacher's guid.She holds it refer to it during the lesson.
                            </p>
                            <p className=' text-[10px] text-black mt-6'>Ans: No/Partially</p>
                            <hr className="border-t border-gray-400 my-2" />
                            <p className=' text-gray-600 text-[10px] my-3'>Reason to sekect No/Partially</p>
                            <p className='text-[10px] text-black'>Lorem ipsum sit ame</p>
                        </div>

                        <div class=" bg-[#E5DED4] bg-opacity-25 rounded-md p-3   gap-4">
                            <p className=' text-black font-bold text-[12px] '>
                                The teacher is using the teacher's guid.She holds it refer to it during the lesson.
                            </p>
                            <p className=' text-[10px] text-black mt-2'>Ans: No/Partially</p>
                            <hr className="border-t border-gray-400 my-2" />
                            <p className=' text-gray-600 text-[10px]'>Comment</p>
                            <p className='text-[10px] text-black'> Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ipsa dolorum quam fugiat expedita quis dolorem?</p>
                            <hr className="border-t border-gray-400 my-2" />
                            <p className=' text-gray-600 text-[10px]'>Reason to sekect No/Partially</p>
                            <p className='text-[10px] text-black'>Lorem ipsum sit ame</p>
                        </div>

                        <div class=" bg-[#E5DED4] bg-opacity-25 rounded-md p-3   gap-4">
                            <p className=' text-black font-bold text-[12px] '>
                                The teacher is using the teacher's guid.She holds it refer to it during the lesson.
                            </p>
                            <p className=' text-[10px] text-black mt-2'>Ans: No/Partially</p>

                        </div>

                        <div class=" bg-[#E5DED4] bg-opacity-25 rounded-md p-3   gap-4">
                            <p className=' text-black font-bold text-[12px] '>
                                The teacher is using the teacher's guid.She holds it refer to it during the lesson.
                            </p>
                            <p className=' text-[10px] text-black mt-2'>Ans: No/Partially</p>
                            <hr className="border-t border-gray-400 my-2" />
                            <p className=' text-gray-600 text-[10px] my-3'>Comment</p>
                            <p className='text-[10px] text-black'> Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ipsa dolorum quam fugiat expedita quis dolorem?</p>
                            <hr className="border-t border-gray-400 my-2" />
                            <p className=' text-gray-600 text-[10px]'></p>
                            <p className='text-[10px] text-black mt-3'></p>
                        </div>

                    </div>

                </Tab>
                <Tab eventKey="AI_Feedback" title="AI Feedback">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4">
                        {/* First Column - AI Feedback */}
                        <div className="bg-[#E5DED4] bg-opacity-25 p-2 rounded-md flex flex-col h-full">
                            <div className='flex items-center'>
                                <img />
                                <p className='text-sm text-gray-500'>AI Feedback</p>
                            </div>
                            <p className='font-bold py-2'>Based on the observation here are the insights</p>
                            <p className='text-sm text-gray-500 text-wrap break-words'>
                                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Reprehenderit, ipsam incidunt! Sunt asperiores perspiciatis optio deserunt blanditiis est molestiae natus, dicta porro eum doloremque et.
                            </p>
                            <p className="font-bold text-sm mt-3">Here are the steps followed:</p>
                            <ul className="list-disc pl-5 text-sm">
                                <li>Do lorem ipsum dolor</li>
                                <li>Do lorem ipsum dolor</li>
                                <li>Do lorem ipsum dolor</li>
                            </ul>
                        </div>

                        {/* Second Column - AI Teacher Chat */}
                        <div className="p-2 bg-[#E5DED4] bg-opacity-25 flex flex-col h-full">
                            <p className="font-bold text-[16px]">AI Teacher Chat</p>

                            <div className="max-h-[350px] overflow-y-auto space-y-4 p-2 rounded-md">
                                {/* AI and User Messages */}
                                <div className="flex items-start space-x-2 border-b-[1px] border-gray-200">
                                    <img src="https://via.placeholder.com/40" alt="AI" className="w-10 h-10 rounded-full" />
                                    <div className="p-3 max-w-sm text-left">
                                        <p className="text-sm">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                                    </div>
                                </div>

                                <div className="flex items-end justify-end space-x-2 border-b-[1px] border-gray-200">
                                    <div className="p-3 max-w-sm text-right">
                                        <p className="text-sm">Sure, I will create a plan for you!</p>
                                    </div>
                                    <img src="https://via.placeholder.com/40" alt="User" className="w-10 h-10 rounded-full" />
                                </div>
                                <div className="flex items-start space-x-2 border-b-[1px] border-gray-200">
                                    <img src="https://via.placeholder.com/40" alt="AI" className="w-10 h-10 rounded-full" />
                                    <div className="p-3 max-w-sm text-left">
                                        <p className="text-sm">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                                    </div>
                                </div>

                                <div className="flex items-end justify-end space-x-2 border-b-[1px] border-gray-200">
                                    <div className="p-3 max-w-sm text-right">
                                        <p className="text-sm">Sure, I will create a plan for you!</p>
                                    </div>
                                    <img src="https://via.placeholder.com/40" alt="User" className="w-10 h-10 rounded-full" />
                                </div>
                                <div className="flex items-start space-x-2 border-b-[1px] border-gray-200">
                                    <img src="https://via.placeholder.com/40" alt="AI" className="w-10 h-10 rounded-full" />
                                    <div className="p-3 max-w-sm text-left">
                                        <p className="text-sm">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                                    </div>
                                </div>

                                <div className="flex items-end justify-end space-x-2 border-b-[1px] border-gray-200">
                                    <div className="p-3 max-w-sm text-right">
                                        <p className="text-sm">Sure, I will create a plan for you!</p>
                                    </div>
                                    <img src="https://via.placeholder.com/40" alt="User" className="w-10 h-10 rounded-full" />
                                </div>

                                
                               
                               
                            </div>
                        </div>
                    </div>


                </Tab>
                <Tab eventKey="Action_plans" title="Action plans">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4">
                        {/* First Column */}
                        <div className="bg-[#E5DED4] bg-opacity-25 p-2 rounded-md  ">
                            <div className='flex justify-between'>
                                <p className=" text-[12px] font-bold">ACTION PLAN NAME 1</p>
                                <p className="text-[12px] text-black">(2/4 items completed)</p>
                            </div>
                            <div className=' flex justify-between my-1 px-2 rounded-md  py-2 bg-[#F0D7E0]'>
                                <p className=' text-gray-800 text-[12px]'>Lorem ipsum dolor sit amet consectetur elit.</p>
                                <span className=' h-5 w-5 rounded-full bg-[#994263] mr-2'></span>

                            </div>
                            <div className=' flex justify-between my-1 px-2 rounded-md  py-2 bg-[#F0D7E0]'>
                                <p className=' text-gray-800 text-[12px]'>Lorem ipsum dolor sit amet consectetur elit.</p>
                                <p className=' font-bold text-[12px] text-orange-400'>Pending</p>

                            </div>
                            <div className=' flex justify-between my-1 px-2 rounded-md  py-2 bg-[#F0D7E0]'>
                                <p className=' text-gray-800 text-[12px]'>Lorem ipsum dolor sit amet consectetur elit.</p>
                                <p className=' font-bold text-[12px] text-orange-400'>Pending</p>

                            </div>
                            <div className=' flex justify-between my-1 px-2 rounded-md  py-2 bg-[#F0D7E0]'>
                                <p className=' text-gray-800 text-[12px]'>Lorem ipsum dolor sit amet consectetur elit.</p>
                                <span className=' h-5 w-5 rounded-full bg-[#994263] mr-2'></span>

                            </div>
                        </div>

                        {/* Second Column */}
                        <div className="bg-[#E5DED4] bg-opacity-25 p-2 rounded-md  ">
                            <div className='flex justify-between'>
                                <p className=" text-[12px] font-bold">ACTION PLAN NAME 1</p>
                                <p className="text-[12px] text-black">(2/4 items completed)</p>
                            </div>
                            <div className=' flex justify-between my-1 px-2 rounded-md  py-2 bg-[#F0D7E0]'>
                                <p className=' text-gray-800 text-[12px]'>Lorem ipsum dolor sit amet consectetur elit.</p>
                                <span className=' h-5 w-5 rounded-full bg-[#994263] mr-2'></span>

                            </div>
                            <div className=' flex justify-between my-1 px-2 rounded-md  py-2 bg-[#F0D7E0]'>
                                <p className=' text-gray-800 text-[12px]'>Lorem ipsum dolor sit amet consectetur elit.</p>
                                <p className=' font-bold text-[12px] text-orange-400'>Pending</p>

                            </div>
                            <div className=' flex justify-between my-1 px-2 rounded-md  py-2 bg-[#F0D7E0]'>
                                <p className=' text-gray-800 text-[12px]'>Lorem ipsum dolor sit amet consectetur elit.</p>
                                <p className=' font-bold text-[12px] text-orange-400'>Pending</p>

                            </div>
                            <div className=' flex justify-between my-1 px-2 rounded-md  py-2 bg-[#F0D7E0]'>
                                <p className=' text-gray-800 text-[12px]'>Lorem ipsum dolor sit amet consectetur elit.</p>
                                <span className=' h-5 w-5 rounded-full bg-[#994263] mr-2'></span>

                            </div>
                        </div>
                    </div>
                </Tab>
            </Tabs>
        </>
    )
}

export default DetailFeedback